import type { HTMLAttributes, ReactNode } from 'react';

export interface HeaderSearchData {
  title?: ReactNode;
  subtitle?: ReactNode;
  bannerChildren?: ReactNode;

  backgroundImage?: string;
  withOverlay?: boolean;

  childrenWrapperContainerProps?: HTMLAttributes<HTMLDivElement>;
  childrenWrapperProps?: HTMLAttributes<HTMLDivElement>;
  hasMobileWrap?: boolean;
  titleColor?: 'blue' | 'white';
}

export interface HeaderSearchProps
  extends Omit<HTMLAttributes<HTMLDivElement>, 'title'>,
    HeaderSearchData {}
